import React from "react";
import ExpertCard from "../components/About//ExpertCard";
import TeamMember from "../components/About//TeamMember";
import ourstory from "../assets/about/ourstory.svg";
import cco from "../assets/about/cco.svg";
import cto from "../assets/about/cto.svg";
import image from "../assets/about/image.png";
import imageCoo from "../assets/about/image_coo.png";
import { motion } from "framer-motion";


function AboutUs() {
  const expertCards = [
    {
      title: "Global Reach",
      description: "Expertefy operates a worldwide expert network that spans all regions and countries, utilizing already registered experts and tailored recruitment for each project."
    },
    {
      title: "Pay Per Call Approach",
      description: "Our commercial terms are straightforward—we only invoice after the completion of an expert call (or project), with all prior efforts provided complimentary."
    },
    {
      title: "Bespoke Approach",
      description: "We deeply understand the specific needs of our clients and custom-recruit fully qualified experts to meet those needs. Our targeted strategy ensures the delivery of high-quality insights and precisely tailored solutions."
    },
    {
      title: "Quality Screening",
      description: "Expertefy consistently requests initial screening questions from clients to administer to experts in comprehensive responses, ensuring relevance and depth. Our clients are equipped to make well-informed decisions based on these detailed answers."
    },
    {
      title: "Dedicated Teams",
      description: "Each account at Expertefy is supported by dedicated teams, led by a key account manager who considers time differences to enhance service effectiveness. Direct access to a main contact for each project streamlines communication and maximizes efficiency."
    },
    {
      title: "Speed",
      description: "We provide round-the-clock service from teams across three continents to ensure the swift delivery of the experts you need. Our commitment is to rapidly provide the right insights through all our services, fulfilling your requests within hours."
    }
  ];

  const teamMembers = [
    {
      name: "Bilal Khan",
      role: "Founder & CCO",
      src: imageCoo,
      description: "is an accomplished entrepreneur with specialized knowledge in the expert network industry. As the Co-Founder and Chief Commercial Officer of Expertefy, he's helped position the company as a top-tier broker of expert services, bridging the gap between subject matter experts and organizations across various sectors. His insight into consulting and business development has been a cornerstone of Expertefy's success. This has enabled the company to provide clients with access to a hand-picked selection of experts from diverse industries. Bilal's hands-on experience with the needs of consultants has shaped Expertefy to meet the needs of its consulting clients exceptionally well."
    },
    {
      name: "Nouman Ahmad",
      role: "CTO",
      src: image,
      description: "is the Chief Technology Officer at Expertefy, leading the company's technology strategy and development of its industry-leading platform. With over 7 years of experience in software engineering and e-commerce solutions, Nouman brings expertise in cutting-edge web technologies and DevOps practices. Prior to Expertefy, Nouman served as a Tech Lead at eWave Commerce, where he was the driving force behind the development and integration of numerous e-commerce sites. He has a proven track record of delivering innovative, performant and secure solutions that drive business growth. Nouman holds a Bachelor's degree in Computer Engineering from the University of Engineering and Technology, Lahore. His passion lies in leveraging technology to solve complex business challenges and provide seamless user experiences."
    }
  ];

  return (
    <main className="flex max-md:px-5 flex-col mb-24 items-center">
      <section className="flex our-story justify-center items-center self-stretch px-16 py-8 w-full text-lg text-center text-white max-md:px-2 max-md:max-w-full">
        <motion.div 
          initial={{ opacity: 0, translateY: -100 }}
          whileInView={{ opacity: 1, translateY: 0 }}
          transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
          viewport={{ once: true }} 
          className="flex  flex-col w-full max-w-[1124px] max-md:max-w-full">
          <img loading="lazy" src={ourstory} alt="Our Story" className="self-center max-md:mb-16 max-w-full aspect-[3.7] w-[200px] sm:w-[480px]" />
          <p className="mt-3 max-md:max-w-full">
            In our previous tenure within a conventional expert network company, we encountered a plethora of operational inefficiencies stemming from unnecessary processes and superfluous tools. These extraneous elements, while ostensibly intended to enhance productivity, instead imposed a burden on operations, exacerbating costs and impeding progress.
            <br /><br />
            Recognizing the inherent flaws in this approach, we embarked on a journey of introspection and innovation and reimagined the expert network landscape. Our analysis revealed that many of the established practices and platforms were not essential to the core functions of the business; rather, they served to complicate workflows and inflate operational overheads unnecessarily.
            <br /><br />
            Recognizing this, we embraced a minimalist approach, stripping away complexity to deliver the same quality at reduced costs. By prioritizing efficiency and agility, Expertefy offers unparalleled service without unnecessary complications, redefining industry standards. Welcome to Expertefy—where simplicity drives innovation.
          </p>
        </motion.div>
      </section>

      <h2 className="mt-20 text-2xl sm:text-5xl font-medium leading-10 text-center light-title capitalize max-md:mt-10">What Sets Us Apart</h2>
      <p className="mt-3.5 text-md sm:text-lg text-center dark-title w-[830px] max-md:max-w-full">
        At Expertefy, we differentiate ourselves through a unique blend of global reach, bespoke service, rigorous quality screening, dedicated support, and unmatched speed. Discover how our distinctive approach empowers your business:
      </p>

      <div className="mt-8 w-full max-w-[1124px] max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          {expertCards.slice(0, 2).map((card, index) => (
            <ExpertCard key={index} title={card.title} description={card.description} />
          ))}
        </div>
      </div>

      <div className="mt-6 w-full max-w-[1124px] max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          {expertCards.slice(2, 4).map((card, index) => (
            <ExpertCard key={index} title={card.title} description={card.description} />
          ))}
        </div>
      </div>

      <div className="mt-6 w-full max-w-[1124px] max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          {expertCards.slice(4, 6).map((card, index) => (
            <ExpertCard key={index} title={card.title} description={card.description} />
          ))}
        </div>
      </div>

      <section className="mt-24 mb-24 w-full max-w-[1124px] max-md:mt-10 max-md:max-w-full">
        <div className="flex flex-col gap-5 max-md:flex-col max-md:gap-0">
          {teamMembers.map((member, index) => (
            <motion.div key={index} className="flex flex-col gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex w-full max-md:flex-col">
                <TeamMember index={index} name={member.name} role={member.role} description={member.description} />
                <motion.img
                  initial={{ opacity: 0, translateX: index == (0|2|4 ) ? -100: 100  }}
                  whileInView={{ opacity: 1, translateX: 0 }}
                  transition={{ duration: 0.5, delay: 0.5, type: "spring" }}
                  viewport={{ once: true }}  
                  loading="lazy" 
                  src={member.src} 
                  alt="Team member portrait" 
                  className=" w-1/2 max-md:w-full mt-10 max-md:aspect-[0.95] aspect-[1.98]" 
                ></motion.img>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default AboutUs;